import { CARE_PASS_ACTION_LABELS, CARE_PASS_ACTIONS, type CarePassAction } from "@alm/domain";

/** The quick filters over the board: everything, or one kind of care. */
export type ActionFilter = "all" | CarePassAction;

export const ACTION_FILTERS: readonly ActionFilter[] = ["all", ...CARE_PASS_ACTIONS];

export const filterLabel = (filter: ActionFilter) =>
  filter === "all" ? "Everything" : CARE_PASS_ACTION_LABELS[filter];
